import React, { useRef } from 'react';
import { useMeasure } from 'react-use';
import { makeStyles } from 'tss-react/mui';

import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import type { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const useStyles = makeStyles()((theme) => ({
  toggleButtonGroupAnimated: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius * 3,
    backgroundColor: theme.palette.background.default,
    gap: theme.spacing(1),
  },
  toggleButton: {
    '&:hover': { backgroundColor: 'transparent' },
    backgroundColor: 'transparent',
  },
  selected: {
    backgroundColor: 'transparent !important',
  },
  slider: {
    position: 'absolute',
    borderRadius: theme.shape.borderRadius * 3,
    transition: '.2s',
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
  },
}));

const ToggleButtonGroupAnimated = ({ className, children, onChange, ...otherProps }: ToggleButtonGroupProps) => {
  const selectedToggleButtonRef = useRef<HTMLAnchorElement>();
  const { classes, cx } = useStyles();
  const [updateMeasureRef] = useMeasure(); // todo this takes a while to render
  return (
    <ToggleButtonGroup
      onChange={(e, val) => {
        if (val !== null) {
          // buttons can be enabled / disabled - we want to block null
          onChange?.(e, val);
        }
      }}
      {...otherProps}
      exclusive
      className={cx(classes.toggleButtonGroupAnimated, className)}
      sharedcomponentid='ToggleButtonGroupAnimated'
    >
      <Box
        id='slider'
        className={classes.slider}
        left={selectedToggleButtonRef.current?.offsetLeft || 0}
        top={selectedToggleButtonRef.current?.offsetTop || 0}
        width={selectedToggleButtonRef.current?.clientWidth || 0}
        height={selectedToggleButtonRef.current?.clientHeight || 0}
      />

      {Array.isArray(children) &&
        children.map((toggleButton) => {
          return (
            <ToggleButton
              key={toggleButton?.key}
              disableRipple
              classes={{ selected: classes.selected, root: classes.toggleButton }}
              ref={(currentTarget) => {
                if (currentTarget && toggleButton.props.value === otherProps.value) {
                  updateMeasureRef(currentTarget);
                  selectedToggleButtonRef.current = currentTarget;
                }
              }}
              {...toggleButton.props}
            />
          );
        })}
    </ToggleButtonGroup>
  );
};
export default ToggleButtonGroupAnimated;
